import { render, staticRenderFns } from "./RankEditor.vue?vue&type=template&id=4469bde4"
import script from "./RankEditor.vue?vue&type=script&lang=js"
export * from "./RankEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports